import { render, staticRenderFns } from "./login-svg-icons.vue?vue&type=template&id=9412bc32&scoped=true"
import script from "./login-svg-icons.vue?vue&type=script&lang=js"
export * from "./login-svg-icons.vue?vue&type=script&lang=js"
import style0 from "./login-svg-icons.vue?vue&type=style&index=0&id=9412bc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9412bc32",
  null
  
)

export default component.exports